import { useState, useMemo, useEffect } from "react";
import { authService } from "../dependencyInjection";
import { unsubscribe } from "../../../../utils";
import { AuthError, RequestStatus } from "../../shared";

export type UsePasswordReset = (userId: number, code: string, newPassword: string) => Promise<void>;

export function usePasswordReset(): [RequestStatus, UsePasswordReset, AuthError] {
  const [status, setStatus] = useState(RequestStatus.None);
  const [error, setError] = useState(AuthError.None);
  const passwordReset: UsePasswordReset = useMemo(
    () => async (userId, code, newPassword) => {
      setStatus(RequestStatus.Pending);
      try {
        await authService.passwordReset(userId, code, newPassword);
      } catch (err) {
      }
    },
    [],
  );

  useEffect(() => {
    const statusSub = authService.status$.subscribe((code) => {
      setStatus(code);
    });
    const errorSub = authService.error$.subscribe((code) => {
      setError(code);
    });
    return unsubscribe(statusSub, errorSub);
  }, []);

  return [status, passwordReset, error];
}
